import {NavLink} from "react-router-dom";

const MiddleSection = ({ message, callToActionText, href }) => {
  return <div className="destacado-middle-section">
    <div className="message">{message}</div>
    <NavLink to={href}>
      <div className="call-to-action">
        <span>{callToActionText}</span>
      </div>
    </NavLink>
  </div>
};

export default MiddleSection;
